function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import useWindowSize from "client/services/hooks/use-window-size";
import useRect from "client/services/hooks/use-rect";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import classnames from "classnames";
import { getComponentsConfig, steps, VARIATIONS } from "../config";
import ParallexParagraphs from "../parallex-paragraphs";
import { StyledScrollParallaxHomepageFirstFoldDesktopComponent } from "./scroll-parallax-homepage-first-fold-desktop-component.scss";
import Colors from "styles/colors";
const ScrollParallaxHomepageFirstFoldDesktopComponent = (props)=>{
    const { alignToLogo, paragraphs, translate, bottomAsset, topAsset, backgroundColor } = props;
    const { width: windowWidth } = useWindowSize();
    const parallexEl = useRef(null);
    const controllerEl = useRef(null);
    const parallexRect = useRect(parallexEl);
    const controllerRect = useRect(controllerEl);
    const variation = windowWidth >= MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH ? VARIATIONS.MEDIUM : VARIATIONS.SMALL;
    const componentsConfig = getComponentsConfig(variation, translate, topAsset, bottomAsset);
    const currentStep = steps[Math.floor(controllerRect.offsetTop * steps.length / parallexRect.clientHeight)];
    return /*#__PURE__*/ _jsx(StyledScrollParallaxHomepageFirstFoldDesktopComponent, {
        className: "scroll-parallax-homepage-first-fold-component-desktop",
        style: {
            backgroundColor: Colors[backgroundColor]
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: classnames("container", {
                "align-to-logo": alignToLogo
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "paragraphs",
                    children: /*#__PURE__*/ _jsx(ParallexParagraphs, {
                        paragraphs: paragraphs
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    ref: parallexEl,
                    className: "parallex",
                    children: /*#__PURE__*/ _jsx("div", {
                        ref: controllerEl,
                        className: "controller",
                        children: componentsConfig.map((cc)=>{
                            const { id, props, component: Component } = cc;
                            return /*#__PURE__*/ _jsx(Component, _object_spread({}, props(currentStep)), id);
                        })
                    })
                })
            ]
        })
    });
};
export default ScrollParallaxHomepageFirstFoldDesktopComponent;
